<!-- 仓库收发明细表 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="medium" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="业务类型：">
            <el-select size="medium" filterable multiple collapse-tags v-model="searchForm.OPERATION_TYPE" placeholder="请选择业务类型" :clearable="true">
              <el-option v-for="item in operationTypeList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker size="medium" v-model="searchForm.OPERATION_DAY" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.COMPANY_TYPE" placeholder="请选择客户类型" :clearable="true">
              <el-option v-for="item in companyTypeList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团餐公司：" v-show="searchForm.COMPANY_TYPE == 1">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择团餐公司" clearable @change="isQueryProject">
              <el-option v-for="item in customer" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：" v-show="searchForm.COMPANY_TYPE == 1">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable @change="isQueryDk">
              <el-option v-for="item in project" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：" v-show="searchForm.COMPANY_TYPE == 1">
            <el-select size="medium" filterable v-model="searchForm.DK_ID" placeholder="请选择档口" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择供应商" :clearable="true">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.AB_NAME"
                :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产部门：">
            <el-select size="medium" filterable v-model="searchForm.PRODUCE_DEPARTMENT_ID" style="width: 100%" :clearable="true">
              <el-option v-for="item in PickingDepartmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领料部门：">
            <el-select size="medium" filterable v-model="searchForm.DEPARTMENT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in departmentList" :key="item.ID" :label="item.DEPARTMENT_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类：">
            <el-select size="medium" filterable v-model="searchForm.FC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in classList" :key="item.FC_ID" :label="item.FC_NAME" :value="item.FC_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="库存批次：">
            <el-input size="medium" v-model="searchForm.BATCH" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="search" :loading="loading">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportData" :loading="loading">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" max-height="520" show-summary :summary-method="getSummaries">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column width="120" prop="OPERATION_TYPE_NAME" label="业务类型"></el-table-column>
          <el-table-column width="100" prop="OERDER_ID" label="单号"></el-table-column>
          <el-table-column width="100" prop="ORDER_DATE" label="单据日期"></el-table-column>
          <el-table-column width="100" prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column width="100" prop="COMPANY_NAME" label="客户"></el-table-column>
          <el-table-column width="100" prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column width="100" prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column width="100" prop="PRODUCE_DEPARTMENT_NAME" label="生产部门"></el-table-column>
          <el-table-column width="100" prop="DEPARTMENT_NAME" label="部门"></el-table-column>
          <el-table-column width="120" prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column width="120" prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column width="80" prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column width="140" prop="BATCH" label="库存批次"></el-table-column>
          <el-table-column width="80" prop="ADD_OR_SUBTRACT" label="库存操作"></el-table-column>
          <el-table-column width="80" prop="PRODUCT_COUNT" label="数量"></el-table-column>
          <el-table-column width="100" prop="PRODUCT_PRICE" label="含税单价"></el-table-column>
          <el-table-column width="100" prop="BEFORE_TAX_PRICE" label="不含税单价"></el-table-column>
          <el-table-column width="100" prop="PRODUCT_FEE" label="含税总金额"></el-table-column>
          <el-table-column width="110" prop="BEFORE_TAX_WORTH" label="不含税总金额"></el-table-column>
          <el-table-column width="80" prop="FC_NAME" label="大类"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { selectTCFun, selectProjectFun, selectDKFun } from 'api/sellOrder';
import { queryDepartment } from 'api/productDepart';
import { supplierList } from 'api/systemSetting';
import { getStockOperationTypeList } from 'api/warehouseManager';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      searchForm: {
        OPERATION_TYPE: [],
        OPERATION_DAY: [date(new Date(), '%F'), date(new Date(), '%F')],
        COMPANY_TYPE: '',
        TC_ID: '',
        PROJECT_ID: '',
        DK_ID: '',
        SUPPLIER_ID: '',
        PRODUCE_DEPARTMENT_ID: '',
        DEPARTMENT_ID: '',
        FC_ID: '',
      },
      operationTypeList: [],
      typeName: '',
      companyTypeList: [
        { label: '团餐', value: 1 },
        { label: '供应商', value: 2 },
      ],
      customer: [],
      project: [],
      dkList: [],
      companys: [],
      // 领料部门
      PickingDepartmentList: [],
      // 部门
      departmentList: [],
      classList: [],
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      loading: false,

    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.WAREHOUSE_TRANSCEIVER_CONDITION.CONDITION) {
      this.searchForm = this.WAREHOUSE_TRANSCEIVER_CONDITION.CONDITION;
      this.currentPage = this.WAREHOUSE_TRANSCEIVER_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (this.searchForm.TC_ID) {
      this.queryProject();
    } else {
      this.searchForm.PROJECT_ID = '';
    }
    if (this.searchForm.PROJECT_ID) {
      this.queryDk();
    } else {
      this.searchForm.DK_ID = '';
    }
    this.queryData();
    this.queryCustomer();
    this.queryPickingDepartment();
    this.queryDepartment();
    this.queryClass();
    this.queryGYSData();
    this.queryOperationTypeList();
  },
  computed: {
    WAREHOUSE_TRANSCEIVER_CONDITION() {
      return this.$store.state.WAREHOUSE_TRANSCEIVER_CONDITION;
    },
  },
  methods: {
    // 业务类型字典（SCM 库存操作类型）
    queryOperationTypeList() {
      getStockOperationTypeList()
        .then((res) => {
          this.operationTypeList = (res || []).map((item) => ({
            label: item.NAME,
            value: Number(item.VALUE),
          }));
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 供应商
    queryGYSData() {
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 9999,
      };
      supplierList(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          if (result.length != 0) {
            this.customer = result[0].company;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 团餐公司改变是否拉取项目点信息
    isQueryProject() {
      if (this.searchForm.TC_ID) {
        this.queryProject();
      } else {
        // 当未选中团餐公司信息时清空项目点和档口信息
        this.searchForm.PROJECT_ID = '';
        this.project = [];
        this.searchForm.DK_ID = '';
        this.dkList = [];
      }
    },
    // 项目点
    queryProject() {
      const params = {
        TC_ID: this.searchForm.TC_ID,
      };
      selectProjectFun(params)
        .then((result) => {
          // this.project = result
          this.project = result[0].list;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 项目点改变时是否拉取档口信息
    isQueryDk() {
      if (this.searchForm.PROJECT_ID) {
        this.queryDk();
      } else {
        this.searchForm.DK_ID = '';
        this.dkList = [];
      }
    },
    // 下拉框获取档口名称
    queryDk() {
      if (!this.searchForm.PROJECT_ID) {
        // 当项目点选框为空时，不获取档口名称
        this.dkList = [];
        return false;
      }
      const params = {};
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      } else {
        this.dkList = [];
        return false;
      }
      selectDKFun(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 领料部门
    queryPickingDepartment() {
      queryDepartment().then((res) => {
        this.PickingDepartmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取部门
    queryDepartment() {
      const params = {
        SERVICE_ID: '10048',
        OTYPE: 5,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        STATUS: 1,
      };
      http.post(params)
        .then((res) => {
          this.departmentList = res;
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 拉取分类
    queryClass() {
      const params = {
        SERVICE_ID: '20001',
        OTYPE: 8,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params)
        .then((res) => {
          this.classList = res;
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    search() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // -----------------------------拉取数据
    queryData() {
      const params = {
        SERVICE_ID: '20001',
        OTYPE: 7,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 业务类型
      if (this.searchForm.OPERATION_TYPE.length != 0) {
        params.OPERATION_TYPE = this.searchForm.OPERATION_TYPE;
      }
      // 操作日期 必传
      if (this.searchForm.OPERATION_DAY) {
        params.START_DATE = date(this.searchForm.OPERATION_DAY[0], '%F');
        params.END_DATE = date(this.searchForm.OPERATION_DAY[1], '%F');
      }
      // 客户类型
      if (this.searchForm.COMPANY_TYPE) {
        params.COMPANY_TYPE = this.searchForm.COMPANY_TYPE;
      }
      // 项目点
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      // 档口
      if (this.searchForm.DK_ID) {
        params.DK_ID = this.searchForm.DK_ID;
      }
      // 供应商
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      // 领料部门
      if (this.searchForm.PRODUCE_DEPARTMENT_ID) {
        params.PRODUCE_DEPARTMENT_ID = this.searchForm.PRODUCE_DEPARTMENT_ID;
      }
      // 部门
      if (this.searchForm.DEPARTMENT_ID) {
        params.DEPARTMENT_ID = this.searchForm.DEPARTMENT_ID;
      }
      // 分类
      if (this.searchForm.FC_ID) {
        params.FC_ID = this.searchForm.FC_ID;
      }
      // 产品编码
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      // 产品名称
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      // 批次
      if (this.searchForm.BATCH) {
        params.BATCH = this.searchForm.BATCH;
      }
      this.loading = true;
      http.post(params).then((res) => {
        if (res[0].DATA.length !== 0) {
          this.tableData = res[0].DATA;
          this.totalCount = res[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.$store.dispatch('SET_WAREHOUSE_TRANSCEIVER_CONDITION', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
        });
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.tableData = [];
        this.totalCount = 0;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 合计列表数据
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'PRODUCT_COUNT' || column.property === 'PRODUCT_FEE' || column.property === 'BEFORE_TAX_WORTH') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        } else {
          sums[index] = '---';
        }
      });
      this.sums = sums;
      return sums;
    },
    exportData() {
      const params = {
        SERVICE_ID: '20001',
        OTYPE: 9,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      for (const key in this.searchForm) {
        if (this.searchForm[key]) {
          switch (key) {
            case 'OPERATION_DAY':
              [params.START_DATE, params.END_DATE] = this.searchForm.OPERATION_DAY;

              break;
            case 'OPERATION_TYPE':
              if (this.searchForm.OPERATION_TYPE[0]) {
                params.OPERATION_TYPE = this.searchForm.OPERATION_TYPE;
              }

              break;

            default:
              params[key] = this.searchForm[key];
              break;
          }
        }
      }
      http.post(params).then((res) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/warehouseTransceiverList.vue